import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './EmailVerification.css';

const EmailVerification = () => {
  const { currentUser, resendEmailVerification, refreshCurrentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleResendEmail = async () => {
    try {
      setLoading(true);
      setError('');
      setMessage('');
      
      await resendEmailVerification();
      setMessage('Email de verificación enviado. Revisa tu bandeja de entrada.');
      setCountdown(60); // 60 segundos de espera
    } catch (error) {
      console.error('Error al reenviar email:', error);
      if (error.code === 'auth/too-many-requests') {
        setError('Demasiados intentos. Espera unos minutos antes de intentar nuevamente.');
      } else {
        setError('Error al enviar el email de verificación. Intenta nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCheckVerification = async () => {
    try {
      setLoading(true);
      setError('');
      setMessage('');
      
      await refreshCurrentUser();
      
      if (currentUser?.emailVerified) {
        setMessage('¡Email verificado correctamente! Redirigiendo...');
        // Redirigir al onboarding después de verificar
        setTimeout(() => {
          window.location.href = '/admin/onboarding';
        }, 1500);
      } else {
        setError('El email aún no ha sido verificado. Revisa tu bandeja de entrada y haz clic en el enlace de verificación.');
      }
    } catch (error) {
      console.error('Error al verificar email:', error);
      setError('Error al verificar el estado del email. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  if (!currentUser) {
    return null;
  }

  return (
    <div className="email-verification-container">
      <div className="email-verification-card">
        <div className="email-verification-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
        </div>
        
        <h2>Verifica tu email</h2>
        <p className="email-verification-text">
          Te enviamos un email de verificación a <strong>{currentUser.email}</strong>
        </p>
        
        <div className="email-verification-steps">
          <div className="step">
            <span className="step-number">1</span>
            <span>Revisa tu bandeja de entrada</span>
          </div>
          <div className="step">
            <span className="step-number">2</span>
            <span>Haz clic en el enlace de verificación</span>
          </div>
          <div className="step">
            <span className="step-number">3</span>
            <span>Regresa aquí y haz clic en "Ya verifiqué mi email"</span>
          </div>
        </div>

        {message && (
          <div className="email-verification-message success">
            {message}
          </div>
        )}

        {error && (
          <div className="email-verification-message error">
            {error}
          </div>
        )}

        <div className="email-verification-actions">
          <button
            onClick={handleCheckVerification}
            disabled={loading}
            className="email-verification-btn email-verification-btn-primary"
          >
            {loading ? 'Verificando...' : 'Ya verifiqué mi email'}
          </button>
          
          <button
            onClick={handleResendEmail}
            disabled={loading || countdown > 0}
            className="email-verification-btn email-verification-btn-secondary"
          >
            {countdown > 0 
              ? `Reenviar en ${countdown}s` 
              : loading 
                ? 'Enviando...' 
                : 'Reenviar email'
            }
          </button>
        </div>

        <div className="email-verification-help">
          <p>
            ¿No recibiste el email? Revisa tu carpeta de spam o 
            <button 
              onClick={handleResendEmail}
              disabled={loading || countdown > 0}
              className="email-verification-link-button"
            >
              solicita uno nuevo
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification; 